import a from "axios";
import {
  API_VERSION,
  BACKEND_URL,
  BACKEND_URL_PROTOCOL,
} from "../constants/Settings";
import { isArray, upperFirst } from "lodash";
import { getTimeOffset } from "../helpers/helpers";
import { actions, store } from "../store/useStore";
import dayjs from "dayjs";
// Removed useRefreshTokenStore import as it's deprecated

const params = new URLSearchParams(window.location.search);
const client_number = params.get('client_number');
const axios = a.create({
  baseURL: `${BACKEND_URL_PROTOCOL}${client_number}-api.${BACKEND_URL}/${API_VERSION}`,
  // baseURL: `http://localhost:8001/${API_VERSION}`,
  headers: {
    "Content-Type": "application/json",
    "fi-client-number": client_number?.toUpperCase(),
    // "fi-device-number": store.auth.activeDeviceIdentifier(),
  },
});

axios.interceptors.request.use(
  (config) => {
    const token = store.auth.authToken();
    const refreshtoken = store.auth.refreshToken();
    const isRefreshTokenAPI = config.url?.includes("auth/refresh-token");

    // const role = roleState().activeRole?.identifier;

    // const { isRefreshing } = store.auth.state();

    // const deviceIdentifier = store.auth.activeDeviceIdentifier();

    if (token) {
      if (!config.headers.hasOwnProperty("fi-device-number")) {
        config.headers["fi-device-number"] =
          store.auth.activeDeviceIdentifier();
      }

      if (
        config.headers.hasOwnProperty("fi-device-number") &&
        (config.headers["fi-device-number"] === "" ||
          config.headers["fi-device-number"] === null ||
          config.headers["fi-device-number"] === undefined)
      ) {
        config.headers["fi-device-number"] =
          store.auth.activeDeviceIdentifier();
      }

      config.headers.Authorization = !isRefreshTokenAPI
        ? `Bearer ${token}`
        : `Bearer ${refreshtoken}`;
      config.headers["X-ROLE"] = store.auth.activeRole()?.identifier;
      config.headers["fi-time-offset"] = getTimeOffset();

      // if (deviceIdentifier) {
      //   config.headers["fi-device-number"] =
      //     store.auth.activeDeviceIdentifier();
      // }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

//! Deprecated
// let refreshSubscribers: Array<(token: string) => void> = [];

// function onRefreshed(token: string) {
//   refreshSubscribers.forEach((callback) => callback(token));
//   refreshSubscribers = [];
// }

//! Deprecated
// async function refreshTokenAndRetry(error: any) {
//   try {
//     const { setIsRefreshing, isRefreshing } = useRefreshTokenStore.getState();
//     const role = roleState().activeRole;
//     const authState = getAuthState();

//     if (!isRefreshing) {
//       setIsRefreshing(true);

//       const token = Cookies.get("refresh-token");

//       roleState().setActiveRole(
//         role ?? (authState.user?.identityInfo?.[0] as any)
//       );

//       const response = await axios.put(
//         `${axios.defaults.baseURL}/auth/refresh-token`,
//         {
//           identity:
//             role?.identifier ?? authState.user?.identityInfo?.[0]?.identifier,
//         },
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         }
//       );

//       if (response.status === 200) {
//         const newToken = response.data.data.tokensInfo.accessToken; // Adjust this based on the actual response structure
//         Cookies.set("session", newToken);

//         setIsRefreshing(false);
//         onRefreshed(newToken);

//         const config = error.config;
//         if (config) {
//           config.headers.Authorization = `Bearer ${newToken}`;
//           return axios(config);
//         }
//       } else {
//         console.log("Refresh token request failed");
//         throw new Error("Refresh token request failed");
//       }
//     } else {
//       return new Promise((resolve) => {
//         refreshSubscribers.push((token) => {
//           error.config.headers.Authorization = `Bearer ${token}`;
//           resolve(axios(error.config));
//         });
//       });
//     }
//   } catch (refreshError) {
//     return Promise.reject(refreshError);
//   }
// }

axios.interceptors.response.use(
  function (response: any) {
    return response;
  },
  async function (error: any) {
    if (
      error.response?.status === 422 &&
      isArray(error?.response?.data?.errors) &&
      error?.response?.data?.errors?.[0]?.message ===
        "Device does not exists with this identifier"
    ) {
      actions.auth.logout();
    } else if (error.response?.status === 401) {
      const _authState = store.auth.state();
      const user = _authState.user;
      const authTokenExpiresAt = _authState.authTokenExpiresAt;
      const refreshTokenExpiresAt = _authState.refreshTokenExpiresAt;
      const refreshToken = _authState.refreshToken;
      const now = dayjs();

      // Check if user auth is invalid then we will set new auth token using refresh token.
      if (
        error?.response?.data?.errors?.[1]?.catchError ===
        "Access token expired"
      ) {
        // debugger;
        // If already refreshing, wait for the refresh to complete
        if (_authState.isRefreshing) {
          // Wait for a short time and retry the request with the new token
          return new Promise((resolve) => {
            setTimeout(async () => {
              // Get the latest token after waiting
              const latestAuthState = store.auth.state();
              const latestToken = latestAuthState.authToken;

              // Retry the failed request with the new token
              const config = error.config;
              if (config) {
                config.headers.Authorization = `Bearer ${latestToken}`;
                resolve(axios(config));
              } else {
                resolve(Promise.reject(error));
              }
            }, 1000); // Wait 1 second before retrying
          });
        }

        // Set refreshing state to true to prevent multiple refresh requests
        actions.auth.isRefreshing(true);

        try {
          // debugger;
          const activeRole = user?.activeUserIdentityInfo;

          const response = await axios.put(
            `${axios.defaults.baseURL}/auth/refresh-token`,
            {
              identity: activeRole?.identifier,
            },
            {
              headers: {
                Authorization: `Bearer ${refreshToken}`,
                "fi-device-number": store.auth.activeDeviceIdentifier() ?? "",
              },
            }
          );

          // debugger;

          // Set refreshing state to false after the request completes
          actions.auth.isRefreshing(false);

          if (response.status === 200) {
            const { accessToken } = response?.data?.data?.tokensInfo;

            // Update tokens in store
            const accessTokenExpiresAt =
              (JSON.parse(atob(accessToken.split(".")[1])) as any).exp * 1000;
            // const refreshTokenExpiresAt =
            //   (JSON.parse(atob(newRefreshToken.split(".")[1])) as any).exp *
            //   1000;

            actions.auth.updateSession(
              accessToken,
              accessTokenExpiresAt
              // newRefreshToken,
              // refreshTokenExpiresAt
            );

            // Retry the failed request
            const config = error.config;
            if (config) {
              config.headers.Authorization = `Bearer ${accessToken}`;
              return axios(config);
            }
          }
        } catch (refreshError) {
          console.log(refreshError);

          // Set refreshing state to false in case of error
          actions.auth.isRefreshing(false);

          actions.auth.logout();
          actions.core.route("/signin");
          return Promise.reject(refreshError);
        }
      }

      // Check if refresh token is expired
      if (now.isAfter(dayjs(refreshTokenExpiresAt))) {
        actions.auth.logout();
        actions.core.route("/signin");
        return Promise.reject(error);
      }

      // Get the current refresh token state

      // Check if access token is expired or will expire soon (within 30 minutes)
      if (now.isAfter(dayjs(authTokenExpiresAt))) {
        // If already refreshing, wait for the refresh to complete
        // if (_authState.isRefreshing) {
        //   // Wait for a short time and retry the request with the new token
        //   return new Promise((resolve) => {
        //     setTimeout(async () => {
        //       // Get the latest token after waiting
        //       const latestAuthState = store.auth.state();
        //       const latestToken = latestAuthState.authToken;

        //       // Retry the failed request with the new token
        //       const config = error.config;
        //       if (config) {
        //         config.headers.Authorization = `Bearer ${latestToken}`;
        //         resolve(axios(config));
        //       } else {
        //         resolve(Promise.reject(error));
        //       }
        //     }, 1000); // Wait 1 second before retrying
        //   });
        // }

        // Set refreshing state to true to prevent multiple refresh requests
        actions.auth.isRefreshing(true);

        try {
          const activeRole = user?.activeUserIdentityInfo;

          const response = await axios.put(
            `${axios.defaults.baseURL}/auth/refresh-token`,
            {
              identity: activeRole?.identifier,
            },
            {
              headers: {
                Authorization: `Bearer ${refreshToken}`,
                "fi-device-number": store.auth.activeDeviceIdentifier() ?? "",
              },
            }
          );

          // Set refreshing state to false after the request completes
          actions.auth.isRefreshing(false);

          if (response.status === 200) {
            const { accessToken } = response?.data?.data?.tokensInfo;

            // Update tokens in store
            const accessTokenExpiresAt =
              (JSON.parse(atob(accessToken.split(".")[1])) as any).exp * 1000;
            // const refreshTokenExpiresAt =
            //   (JSON.parse(atob(newRefreshToken.split(".")[1])) as any).exp *
            //   1000;

            actions.auth.updateSession(
              accessToken,
              accessTokenExpiresAt
              // newRefreshToken,
              // refreshTokenExpiresAt
            );

            // Retry the failed request
            const config = error.config;
            if (config) {
              config.headers.Authorization = `Bearer ${accessToken}`;
              return axios(config);
            }
          }
        } catch (refreshError) {
          // Set refreshing state to false in case of error
          actions.auth.isRefreshing(false);
          actions.auth.logout();
          actions.core.route("/signin");
          return Promise.reject(refreshError);
        }
      }

      if (
        error?.response?.data?.errors?.[0]?.message ===
        "Token does not exists with this identifier"
      ) {
        actions.auth.logout();
        actions.core.route("/signin");
        return Promise.reject(error);
      }

      return Promise.reject(error);
    } else {
      if (isArray(error?.response?.data?.errors)) {
        error?.response?.data?.errors?.forEach((error: any) => {
          Object.values(error).forEach((value: any) => {
            actions.core.throwError(
              upperFirst(value as string) ?? "Something went wrong"
            );
          });
        });
      } else {
        const _errors = Object.values(error?.response?.data?.errors);

        _errors.forEach((value: any) => {
          actions.core.throwError(
            upperFirst(value as string) ?? "Something went wrong"
          );
        });
      }

      return Promise.reject(error);
    }
  }
);

export default axios;
